import React from 'react';
import './ImportTemplateModal.css';
import { getTranslation } from '../../assets/creator/translations';
import Basic from '../FileDrag/FileDrag';

const ImportTemplateModalContent = (props) => (
    
    <React.Fragment>
        <div className='import-template-modal__title'>{getTranslation("Msg_ImportXmlTemplate")}</div>
        <div className='import-template-modal__text'>
            <p>{getTranslation("Msg_ImportOnlyCreatorXml")}</p>
        </div>
        <Basic
            accept={"text/xml"}
            onSelect={props.onImport}
            onClick={props.handleClose}
            onChange={props.onChange}
            />
    </React.Fragment>
)

const ImportTemplateModal = (props) => {
    if (!props.show) {
        return null;
    }

    return (
        <div className='import-template-modal'>
            <section className='import-template-modal__main import-template'>
                <ImportTemplateModalContent {...props} />
            </section>
        </div>
    );
}

export default ImportTemplateModal;